import React from 'react';

const BelongsToSymbol = () => {
	return (
		<>
			<div className="belongs-to-symbol">&#8712;</div>
		</>
	);
};

export default BelongsToSymbol;
